import {twJoin} from "tailwind-merge";

export function AnankeTempPageTitle({title, className}: {title: string; className?: string}) {
    return <div className={twJoin("w-full text-ds-font-heading-large", className)}>{title}</div>;
}
